export interface Dictionary<T> {
  [idx: string]: T;
}

export interface Translation {
  campaignName: string;
  campaignTitle: string;
  clientTitle: string;
  campaignLabel: string;
  splashIntro: string;
  sharebutton: string;
  embedbutton: string;
  emdedCopyTitle: string;
  embedCopy: string;
  copyToClipboard: string;
  scrollDown: string;
  clientUrl: string;
  campaignUrl: string;
  begin: string;
  informationCopy: string;
  exploreButton: string;
  embedCopyTitle: string;
  infoTitle: string;
  altText: string;
  valueMapDesc: string[];
  protanopiaSplash: string;
  deuteranopiaSplash: string;
  tritanopiaSplash: string;
  protanopiaInfo: string;
  deuteranopiaInfo: string;
  tritanopiaInfo: string;
  protanopiaButton: string;
  deuteranopiaButton: string;
  tritanopiaButton: string;
  normalViewTab: string;
  pinterestLink: string;
  instagramLink:string;
  linkedinLink: string;
}

export const INIT_TRANSLATIONS: Translation = {
  campaignName: "",
  campaignTitle: "",
  clientTitle: "",
  campaignLabel: "",
  splashIntro: "",
  sharebutton: "",
  embedbutton: "",
  emdedCopyTitle: "",
  embedCopy: "",
  copyToClipboard: "",
  scrollDown: "",
  clientUrl: "",
  campaignUrl: "",
  begin: "",
  informationCopy: "",
  exploreButton: "",
  embedCopyTitle: "",
  infoTitle: "",
  altText: "",
  valueMapDesc: [],
  protanopiaSplash: "",
  deuteranopiaSplash: "",
  tritanopiaSplash: "",
  protanopiaInfo: "",
  deuteranopiaInfo: "",
  tritanopiaInfo: "",
  protanopiaButton: "",
  deuteranopiaButton: "",
  tritanopiaButton: "",
  normalViewTab: "",
  pinterestLink: "",
  instagramLink:"",
  linkedinLink: "",
};

export interface ImagesData{
  id: string;
  label: string;
  parent: string;
  order: number;
  imgSrc:string;
  imgSrcChanged:string;  
}

export interface ProtanopiaData {
  id: string;
  label: string;
  parent: string;
  order: number;
  imgSrc:string;
  imgSrcChanged:string;  
}

export interface DeuteranopiaData {
  id: string;
  label: string;
  parent: string;
  order: number;
  imgSrc:string;
  imgSrcChanged:string;  
}

export interface TritanopiaData {
  id: string;
  label: string;
  parent: string;
  order: number;
  imgSrc:string;
  imgSrcChanged:string;  
}





// WEBPACK FOOTER //
// ./src/models/models.ts